import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/js/api.js';
import '@/assets/scss/innerpage.scss'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')



